import React from 'react';
import Layout from "../components/layout";
import SEO from "../components/seo";
import LoginSect from "../components/account/login/login"

const Login = (props) => {
    return (
        <Layout>
        <SEO title="Login" />
        <LoginSect />
        </Layout>
    );
}
export default Login;